import React from 'react';

const LogoManagementPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default LogoManagementPage;
